import { createContext, useCallback, useContext, useState } from "react";
import RequestModal from "./RequestModal";

const ModalContext = createContext({ openRequest: () => {} });

// Глобальный провайдер попапа заявки: openRequest() доступен из любого компонента.
export function ModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openRequest = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  return (
    <ModalContext.Provider value={{ openRequest }}>
      {children}
      <RequestModal open={open} onClose={close} />
    </ModalContext.Provider>
  );
}

export const useRequestModal = () => useContext(ModalContext);
